class DataHelper {

  public static get = async (
    url: URL,
    signal?: AbortSignal,
    keepalive: boolean = false,
  ) => {
    const response = await fetch(url.toString(), {
      signal,
      keepalive: keepalive,
      credentials: `omit`,
    });
    if (!response.ok) {
      throw new Error(`Failed to load data. ${ response.status }`);
    }
    return await response.json();
  }

  public static post = async (
    url: URL,
    values: string,
  ) => {
    try {
      const response = await fetch(url.toString(), {
        method: `POST`,
        keepalive: true,
        credentials: `omit`,
        headers: {
          'Content-Type': `application/json`,
        },
        body: values,
      });
      if (!response.ok) {
        throw new Error(`Failed to save data. ${ response.status }`);
      }
      return await response.json();

    } catch (error: unknown) {
      console.error(error);
    }
  }

  public static getBackendUrl = (language: string, environment: string) => {
    language = language.toLowerCase();
    const hosts: Record<string, Record<string, string>> = {
      nl: {
        production: import.meta.env.VITE_BACKEND_URL_NL,
        staging: import.meta.env.VITE_BACKEND_URL_NL_STAGING,
        local: import.meta.env.VITE_BACKEND_URL_NL_LOCAL,
      },
      en: {
        production: import.meta.env.VITE_BACKEND_URL_EN,
        staging: import.meta.env.VITE_BACKEND_URL_EN_STAGING,
        local: import.meta.env.VITE_BACKEND_URL_EN_LOCAL,
      },
    };

    console.log(`Selecting backend ${ language } / ${ environment }`);

    let backendHost = hosts[language][environment];
    if (!backendHost) {
      console.warn(`Backend host is not defined, falling back to default.`);
      backendHost = hosts[`en`][`production`];
    }

    return backendHost;
  }

}

export default DataHelper;
